import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import styled from 'styled-components';
import * as folioActions from "../../actions/folio-actions";
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import { bindActionCreators, compose } from 'redux';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';


const Thumb = styled(Link)`
  font-size: 15px;
`;

const NewProject = styled(Link)`
  text-align: center;
  vertical-align: top;
  width: 200px;
  
  div {
    font-size: 100px;
  }
`;




class Projects extends React.Component  {
  state = {};

  saveData = (data) => {
    const { actions, firebase } = this.props;
    firebase.ref('projects').set(data).then(() => {
      actions.showNotification('Project re-sorted.');
      setTimeout(() => { actions.hideNotification(); }, 8000);
    });
  };

  onSort = (data) => {
    const sortedProjects = { ...this.props.sortedProjects }
    const keys = Object.keys(sortedProjects);
    const oldOrder = sortedProjects[keys[data.oldIndex]].order;
    const newOrder = sortedProjects[keys[data.newIndex]].order;
    sortedProjects[keys[data.oldIndex]].order = newOrder;
    sortedProjects[keys[data.newIndex]].order = oldOrder;
    this.saveData(sortedProjects);
  };

  render() {
    const { handleDeleteProject, sortedProjects, activeTab } = this.props;
    const SortableContainer = sortableContainer(({children}) => {
      return <div>{children}</div>;
    });

    const SortableItem = sortableElement(({ project, i }) => {
      const imageUrl =  project.thumbnailPath && project.thumbnailPath.url;
      return (
          <Thumb className="admin--project" to={`/add/${ project.id }`} key={ i }>
            <img src={ imageUrl } style={ { width: '200px', height: 'auto' } } alt="" />
            { project.name }
            <img style={ { zIndex: 1000, display: 'inline', verticalAlign: '-12px' } }
                 onClick={  (e) => handleDeleteProject(e, project) }
                 src="data:image/svg+xml,%3Csvg%20fill%3D%22%23ab3029%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M6%2019c0%201.1.9%202%202%202h8c1.1%200%202-.9%202-2V7H6v12zM19%204h-3.5l-1-1h-5l-1%201H5v2h14V4z%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%3C/svg%3E"  alt="Remove" />
          </Thumb>
      )
    });

    return (<section className={activeTab === 'projects' ? 'tab-content is-enabled' : 'tab-content'}>
      <p>Click and hold a thumbnail, then drag to re-order project slides.</p>
      <SortableContainer axis="xy" pressDelay={ 200 } onSortEnd={(data) => {
        this.onSort(data)
      }}>
        {sortedProjects && sortedProjects.map((project, index) =>
            <SortableItem key={`item-${index}`} i={index} index={index} project={project}/>
        )}
        <NewProject className="admin--project admin--project--new" to={`/add`} key="new-project">
          <div>+</div>
        </NewProject>
      </SortableContainer>


    </section>)
  }
}

Projects.propTypes = {
  sortedProjects: PropTypes.array,
  handleDeleteProject: PropTypes.func,
  activeTab: PropTypes.string
};


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['/projects']),
    connect(
        (state) => ({
          folio: state.folio,
          projects: state.firebase.data.projects,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(Projects)



// WEBPACK FOOTER //
// ./src/containers/admin/Projects.js